const validate = values => {
  const errors = {}
  if (!values.quizTitle) {
    errors.quizTitle = 'این فیلد الزامی است'
  }
  if (!values.questions || !values.questions.length) {
    errors.questions = { _error: 'حداقل یک سوال باید اضافه شود' }
  } else {
    const questionsArrayErrors = []
    values.questions.forEach((question, questionIndex) => {
      const questionErrors = {}
      if (!question || !question.question) {
        questionErrors.question = 'این فیلد الزامی است'
        questionsArrayErrors[questionIndex] = questionErrors
      }
        if (!question.questionType){
          questionErrors.questionType =  'این فیلد الزامی است';
          questionsArrayErrors[questionIndex] = questionErrors;
          
        }

      if (question && question.answers && question.answers.length) {
        const answerArrayErrors = []
        question.answers.forEach((answer, answerIndex) => {
        if (!answer || !answer.length) {
            answerArrayErrors[answerIndex] = 'این فیلد الزامی است'
          }
        })

        if (answerArrayErrors.length) {
          questionErrors.answers = answerArrayErrors
          questionsArrayErrors[questionIndex] = questionErrors
        }

        if (question.answers.length > 4) {
          if (!questionErrors.answers) {
            questionErrors.answers = []
          }
          questionErrors.answers._error = 'اضافه کردن بیشتر پاسخ ممکن نیست'
          questionsArrayErrors[questionIndex] = questionErrors
        }
        if (!question.correctAnswer){
          questionErrors.correctAnswer =  'این فیلد الزامی است';
          questionsArrayErrors[questionIndex] = questionErrors;
         }
      }

      if (!question.answers || question.answers.length === 0) {
        if (!questionErrors.answers) {
          questionErrors.answers = []
        }
        questionErrors.answers._error = 'حداقل یک پاسخ باید وارد شود'
        questionsArrayErrors[questionIndex] = questionErrors
      }

    })

    if (questionsArrayErrors.length) {
      errors.questions = questionsArrayErrors
    }
  }
  return errors
}

export default validate